export class Address {
    constructor(public recipientInfo = '',
        public line1 = '',
        public line2 = '',
        public townOrCity = '',
        public province = '',
        public postCode = '',
        public country = '',
        public nzPostDpId?: number
    ) {
    }
}

export class AddressList {
    constructor(public addresses: Address[]) {
    }
}

export interface NZPostAddress {
    AddressLine1: string;
    AddressLine2: string;
    Physical: 'Y' | 'N';
    Postal: 'Y' | 'N';
    Suburb: string;
    CityTown: string;
    MailTown: string;
    Postcode: string;
    DPID: string;
    SourceDesc: string;
}

export interface NZPostDetailsResponse {
    success: boolean;
    details: NZPostAddress[];
    status: string;
}

export interface Country {
    label: string;
    value: string;
}

export class JavaContactAddress {
    public nzPostDpId: number;
    constructor(public recipientInfo = '',
        public line1 = '',
        public line2 = '',
        public townOrCity = '',
        public province = '',
        public postcode = '',
        public country = ''
    ) {
    }
}
